import CoursePlanEvent from './CoursePlanEvent';
export default CoursePlanEvent;
